import { render, staticRenderFns } from "./modifyAvator.vue?vue&type=template&id=2358142c"
import script from "./modifyAvator.vue?vue&type=script&lang=js"
export * from "./modifyAvator.vue?vue&type=script&lang=js"
import style0 from "./modifyAvator.vue?vue&type=style&index=0&id=2358142c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports